export enum EmailResult {
	doesntApply = -1,
	success = -2,
	successWithFailure = -3,
	failure = -4
}

export enum EmailAddressType {
	Primary = -1,
	Work = -2,
	Personal = -3
}

export enum RelevantContext {
	Employee = -1,
	Supervisor = -2,
	HrManager = -3,
	AssignedAdmin = -4,
	PrimaryTenantAdmin = -5,
	PrimaryEmployerAdmin = -6,
	HelpFeedbackAdmin = -7,
	MainContact = -8, 
	BenefitsContact = -9,
	BenefitDeductionsContact = -10,
	PayrollContact = -11
}